import { render, staticRenderFns } from "./EventBasicKPI.vue?vue&type=template&id=24888540&"
import script from "./EventBasicKPI.vue?vue&type=script&lang=js&"
export * from "./EventBasicKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports